import { useMemo } from 'react';
import { GlobalSettingsKeys } from '../../components/Settings/GlobalSettingsKeys';
import { useGetGlobalSetting } from '../../components/Settings/GlobalSettingsProvider';
import { EarconProps } from './types';
import { Earcon } from './__internal__/Earcon';

export const useEarcon = (props: EarconProps): Earcon => {
  const shouldPlayEarcon =
    useGetGlobalSetting(GlobalSettingsKeys.PLAY_EARCONS)?.toString().toLocaleLowerCase() === 'true';
  return useMemo(() => {
    return new Earcon({ source: shouldPlayEarcon ? props.source : undefined });
  }, [props.source, shouldPlayEarcon]);
};
